import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, IconButton, Box, Typography, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FormPreview from "../components/FormPreview";
import {
  fetchClientDetailData,
  processElement,
  processHighlightRemovePara,
} from "../utils/formUtils";
import { USERROLE } from "../utils/commonConstant";

const ContractPresentModePopup = ({
  open,
  onClose,
  elements,
  clientId,
  previewTitle,
  isSignatureDisabled = false,
  trackChangeDisplayBy = USERROLE.ADMIN,
}) => {
  const [mergedElements, setMergedElements] = useState([]);

  const fieldMappings = {
    SubcontractorName: "SubcontractorName",
    FirstName: "FirstName",
    LastName: "LastName",
    Email: "Email",
    PersonalNo: "MobileNumber",
    Mobile: "MobileNumber",
    Address: "AddressLine1",
    City: "City",
    RecipientRole: "Subcontractor",
    Zipcode: "Postcode",
    ClientName: "ClientName",
    ClientAddress: "ClientAddress",
  };

  useEffect(() => {
    if (!open) return;
    // Function to process signature elements by disabling them
    const disableSignatureElements = (element) => {
      if (element.type === "signature") {
        return { ...element, props: { ...element.props, disabled: true } };
      }

      if (element.type === "horizontalContainer" && element.items) {
        element.items = element.items.map(disableSignatureElements);
      }

      return element;
    };

    async function fetchData() {
      try {
        const data = await fetchClientDetailData(clientId);
        if (data.ClientAddress) {
          data.ClientAddress = data.ClientAddress.replace(/\n/g, ", ");
        }
        console.log(data, "Data");
        if (data && elements) {
          const processList = (list) =>
            list.map((element) => {
              return processElement(element, data, fieldMappings);
            });
          const processedElements = processList(elements);
          const updatedElements = isSignatureDisabled
            ? processedElements.map(disableSignatureElements)
            : processedElements;
          const processParaAttrList = (list) =>
            list.map((element) => {
              return processHighlightRemovePara(
                element,
                localStorage.getItem("Role")
              );
            });
          const processedParaElementsAttr =
            processParaAttrList(updatedElements);
          setMergedElements(processedParaElementsAttr);
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    }

    fetchData();
  }, [clientId, open, elements]);

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
    maxHeight: "90vh",
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="form-preview-title"
        aria-describedby="form-preview-description"
        sx={{ backgroundColor: "#CCCCCC" }}
        disableEnforceFocus
        disableAutoFocus
      >
        <Box sx={{ ...modalStyle, backgroundColor: "#CCCCCC" }}>
          <Box
            sx={{
              position: "sticky",
              top: 8,
              right: 8,
              textAlign: "right",
            }}
          >
            <Tooltip title="Close" arrow>
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  color: "black",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="caption" display="block">
              Close
            </Typography>
          </Box>
          {previewTitle && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                id="form-preview-title"
                variant="h4"
                component="h3"
                align="center"
                flexGrow={1}
              >
                {previewTitle ?? "Form Preview"}
              </Typography>
            </Box>
          )}

          <FormPreview
            elements={mergedElements}
            trackChangeDisplayBy={trackChangeDisplayBy}
            isShowTrackHistory={false}
            isEditable={false}
            isPresentMode={true}
          />
        </Box>
      </Modal>
    </>
  );
};

ContractPresentModePopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
};

export default ContractPresentModePopup;
